import { ReactComponent as SFCPT } from '../../../assets/icons/santander.svg';
import { encaminharEcommerce } from '../../../api/apiCarros';
import EcommerceContext from '../../hooks/EcommerceProvider';
import css from '../../pages/ficha/infoTop.module.css';
import { useContext } from 'react';

export default function ButtonEcommerce({ viatura, infoJson, height, width, margin }) {
  const { stateEcommerce } = useContext(EcommerceContext);

  const handlerEcommerce = async event => {
    try {
      event.preventDefault();
      await encaminharEcommerce(viatura.CodViatura, infoJson, stateEcommerce.eurotaxCode).then(
        data => {
          data.success ? window.open(data.URL, '_blank', 'noreferrer') : console.log('data', data);
        },
      );
    } catch (error) {
      console.log('error', error);
    }
  };

  return (
    <>
      <button
        onClick={event => {
          handlerEcommerce(event);
        }}
        style={{
          border: 'none',
          height: height,
          width: width,
          justifyContent: 'center',
          borderRadius: '23px',
          flexDirection: 'row',
          margin: margin,
        }}
        className={`${css.btnPartilharFicha} ${css.btn_ficha}  btn-blinear `}
      >
        <SFCPT style={{ marginRight: '5px' }} /> FINANCIAMENTO
      </button>
    </>
  );
}
